import { Skeleton } from '@/common/components/ui/skeleton';

export const OrgBillingTabSkeleton = () => (
  <div className="space-y-5">
    <div className="flex items-center justify-between">
      <div className="flex flex-col gap-1">
        <Skeleton className="h-5 w-[140px]" />
        <Skeleton className="h-4 w-[260px]" />
      </div>
      <Skeleton className="h-9 w-[120px]" />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Skeleton className="h-[150px] rounded-2xl" />
      <Skeleton className="h-[150px] rounded-2xl" />
    </div>
  </div>
);
